import {SESSION_STORAGE_ATTEMPT_TO_BUY_TICKET_INFO} from '../constant';
import {AttemptToBuyTicketInfo} from '../type';

export function getAttempToBuyTicketInfoFromSessionStorage() {
  const stringifiedBuyTicketInfo = window.sessionStorage.getItem(
    SESSION_STORAGE_ATTEMPT_TO_BUY_TICKET_INFO
  );

  if (!stringifiedBuyTicketInfo) {
    return;
  }

  const attempToBuyTicketInfo: AttemptToBuyTicketInfo = JSON.parse(
    stringifiedBuyTicketInfo
  );
  window.sessionStorage.removeItem(SESSION_STORAGE_ATTEMPT_TO_BUY_TICKET_INFO);
  return attempToBuyTicketInfo;
}
